import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MasterService } from 'src/app/pages/master/master.service';

@Component({
  selector: 'app-modal-change-fuels-attributes',
  templateUrl: './modal-change-fuels-attributes.component.html',
})
export class ModalChangeFuelsAttributesComponent {
  @Input() modalTitle: string = '';
  @Input() modalQuestion: string = '';
  @Input() modalMessage: string = '';
  @Input() attributeToChange: 'SECDate' | 'SECFolio' | 'SECCertificate' | null =
    null;
  @Input() attributeForm: FormGroup = new FormGroup({});
  @Output() modalDismissed: EventEmitter<string> = new EventEmitter<string>();
  @Output() modalClosed: EventEmitter<string> = new EventEmitter<string>();
  date = new Date();
  maxDate = this.date.toISOString().split('T')[0];

  /**
   * Función de desecho del modal.
   * @param {string} value Tecla con que fue desechado.
   */
  d(value: string): void {
    this.modalDismissed.emit(value);
  }

  /**
   * Función de cierre del modal.
   * @param {string} value Tecla con que fue cerrado.
   */
  c(value: string): void {
    this.modalClosed.emit(value);
  }
}
